import { useEffect } from 'react';
import { useOktaAuth, LoginCallback } from '@okta/okta-react';
import { LoginCallbackError } from '@app/components/LoginCallbackError';
import { Spinner } from '@app/components/Loader';
import Box from '@mui/material/Box';
import * as Sentry from '@sentry/react';
import { clearAuthCodeOnAuthSdkError } from '@app/helpers/auth';
import {
  clearAuthRedirectSessionMarkers,
  resetAuthLoaderRedirectGuard,
} from '@app/loaders/authLoader';

const LoginCallbackHandler = () => {
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      clearAuthRedirectSessionMarkers();
      resetAuthLoaderRedirectGuard();
    }
  }, [authState?.isAuthenticated]);

  return (
    <LoginCallback
      errorComponent={error => {
        const actualError = error?.error || error;
        const isPKCEError =
          actualError?.message?.includes('PKCE codeVerifier') ||
          actualError?.message?.includes('codeVerifier from storage');

        if (isPKCEError) {
          clearAuthRedirectSessionMarkers();
          resetAuthLoaderRedirectGuard();
        }

        Sentry.captureException(actualError, {
          tags: {
            errorType: isPKCEError ? 'pkce_error' : 'auth_error',
          },
        });
        clearAuthCodeOnAuthSdkError(error);
        return (
          <LoginCallbackError
            error={error}
            onClick={() => {
              clearAuthRedirectSessionMarkers();
              resetAuthLoaderRedirectGuard();
              window.location.href = window.location.origin;
            }}
          />
        );
      }}
      loadingElement={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <Spinner />
        </Box>
      }
    />
  );
};

export default LoginCallbackHandler;
